import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getAddressOfOrder, getEventById, getTicketTypeById, getTicketTypeInfosByTicketTypeId } from "ticketino-api-client";

import Header from "./components/Header";
import Footer from "./components/Footer";

import imgIconProgressCompleted from "../images/progress-bar/ball-completed.svg";
import imgIconProgress from "../images/progress-bar/ball-progress.svg";

import imgIconInfo from "../images/icons/info.svg";

const Ticket = () => {
    const [orderId] = useState(sessionStorage.getItem("orderId"));
    const [token] = useState(sessionStorage.getItem("token"));

    const [countSaturdayTickets] = useState(sessionStorage.getItem("countSaturdayTickets"));
    const [countSundayTickets] = useState(sessionStorage.getItem("countSundayTickets"));

    const [isError, setIsError] = useState(false);

    const [buyerInfo, setBuyerInfo] = useState({
        salutation: "",
        firstName: "",
        name: "",
        email: "",
        function: "",
        countryId: 176,
        email: "",
        confirmemail: "",
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [order, setOrder] = useState({});
    const [tickets, setTickets] = useState([]);

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        if (orderId) {
            loadOrder(orderId);
        }
    }, [orderId]); //gets called when an order is started

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const removePromotionCode = async (promotion) => {
        try {
            const response = axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotion}`);
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            if (!updatedOrder?.tickets || updatedOrder.tickets.length === 0) {
                navigate(`/${language}/home`);
            }

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);

                    const info = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo }
                })
            )

            setOrder(updatedOrder);
            setTickets(updatedTickets);

            const address = await getAddressOfOrder(orderId);
            setBuyerInfo({ ...buyerInfo, ...address });
        }
        catch (error) {
            navigate(`/${language}/home`);
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const onSubmit = async () => {
        // Validate the form
        const validAdditionalFields = validateAdditionalFields();

        if (!validAdditionalFields) return;

        // Prepare and run all update requests in parallel
        const updatePromises = tickets
            .filter(ticket => ticket.ticketType?.additionalFields?.length > 0)
            .map(ticket => updateTicketAddress(ticket));

        try {
            await Promise.all(updatePromises);
            navigate(`/${language}/overview`);
        } catch (error) {
            console.error("Failed to update one or more ticket addresses:", error);
        }
    };

    const onClickFillUserData = (ticketId) => {
        tickets.forEach(t => {

            if (t.id === ticketId) {
                t.option1 = buyerInfo.firstName;
                t.option2 = buyerInfo.name;
                t.option9 = buyerInfo.email;
            }
        });

        setTickets([...tickets]);
    };


    const validateAdditionalFields = () => {
        let isValid = true;

        const updatedTickets = tickets.map((ticket) => {
            let ticketIsValid = true;

            ticket.ticketType?.additionalFields?.forEach((field) => {
                const fieldName = getFieldNameByFieldId(field.saveToField);
                const value = ticket[fieldName] || "";

                if (field.isMandatory) {
                    switch (field.fieldControl) {
                        case 2: // Dropdown
                        case 3: // Textbox
                        case 5: // Emailbox
                            if (!value || value.trim() === "") {
                                ticketIsValid = false;
                            }
                            break;

                        case 0: // Radio button list
                            if (!value || value.trim() === "") {
                                ticketIsValid = false;
                            }
                            break;

                        case 1: // Checkbox list (stored as comma-separated string)
                            if (!value || value.split(",").filter(Boolean).length === 0) {
                                ticketIsValid = false;
                            }
                            break;

                        default:
                            break;
                    }
                }
            });

            setIsError(isValid)

            if (!ticketIsValid) {
                isValid = false;
            }

            return {
                ...ticket,
                isValid: ticketIsValid,
            };
        });


        setTickets(updatedTickets); // update state with `isValid` flags
        return isValid;
    };


    const updateTicketAddress = async (ticket) => {
        let ticketAddress = {
            company: ticket.company,
            firstname: ticket.firstName,
            name: ticket.lastname,
            email: ticket.email,
            salutation: ticket.salutation,
            title: ticket.title,
            function: ticket.function,
            position: ticket.position,
            birthDate: ticket.birthDate,
            additionalCompany: ticket.additionalCompany,
            street: ticket.street,
            postOffice: ticket.postOffice,
            postCode: ticket.postCode,
            city: ticket.city,
            country: ticket.country,
            phone: ticket.phone,
            mobile: ticket.mobile,
            phoneDial: ticket.phoneDial,
            fax: ticket.fax,
            url: ticket.url,
            branch: ticket.branch,
            companyEmail: ticket.companyEmail,
            customvalue1: ticket.customValue1,
            customvalue2: ticket.customValue2,
            customvalue3: ticket.customValue3,
            customvalue4: ticket.customValue4,
            option1: ticket.option1,
            option2: ticket.option2,
            option3: ticket.option3,
            option4: ticket.option4,
            option5: ticket.option5,
            option6: ticket.option6,
            option7: ticket.option7,
            option8: ticket.option8,
            option9: ticket.option9,
            option10: ticket.option10,
            option11: ticket.option11,
            option12: ticket.option12,
            option13: ticket.option13,
            option14: ticket.option14,
            option15: ticket.option15,
            option16: ticket.option16,
            option17: ticket.option17,
            option18: ticket.option18,
            option19: ticket.option19,
            option20: ticket.option20,
            option21: ticket.option21,
            option22: ticket.option22,
            option23: ticket.option23,
            option24: ticket.option24,
        };

        await axios.put(`${baseUrl}/Ticket/${ticket.id}/Address`, ticketAddress)
            .then((res) => {
            })
            .catch((error) => {
            });
    }

    const onBackClick = async () => {
        const promotioncode = sessionStorage.getItem("addedPromotion");

        if (promotioncode?.length > 0) {
            await removePromotionCode(promotioncode);
        }

        navigate(-1)
    }

    const getFieldNameByFieldId = (fieldId) => {

        if (fieldId === 1) {
            return "option1";
        }
        else if (fieldId === 2) {
            return "option2";
        }
        else if (fieldId === 3) {
            return "option3";
        }
        else if (fieldId === 4) {
            return "option4";
        }
        else if (fieldId === 5) {
            return "option5";
        }
        else if (fieldId === 6) {
            return "option6";
        }
        else if (fieldId === 7) {
            return "option7";
        }
        else if (fieldId === 8) {
            return "option8";
        }
        else if (fieldId === 9) {
            return "option9";
        }
        else if (fieldId === 10) {
            return "option10";
        }
        else if (fieldId === 11) {
            return "option11";
        }
        else if (fieldId === 12) {
            return "option12";
        }
        else if (fieldId === 13) {
            return "option13";
        }
        else if (fieldId === 14) {
            return "option14";
        }
        else if (fieldId === 15) {
            return "option15";
        }
        else if (fieldId === 16) {
            return "option16";
        }
        else if (fieldId === 17) {
            return "option17";
        }
        else if (fieldId === 18) {
            return "option18";
        }
        else if (fieldId === 19) {
            return "option19";
        }
        return "option20";
    }

    const mapAddtionalFields = (ticket, additionalFields) => {
        let formElements = [];

        for (let i = 0; i < additionalFields.length; i++) {
            const field = additionalFields[i];
            const fieldName = getFieldNameByFieldId(field.saveToField);
            const isRequired = field.isMandatory;
            const value = ticket[fieldName] || "";
            const baseLabel = field.title[languageId] || "Field";
            const label = isRequired ? `${baseLabel} *` : baseLabel;

            let inputElement = null;

            switch (field.fieldControl) {
                case 2: // Dropdown
                    inputElement = (
                        <select
                            className="form-select"
                            required={isRequired}
                            value={value}
                            onChange={(e) =>
                                handleAdditionalFieldChange(ticket.id, field.saveToField, e.target.value)
                            }
                        >
                            <option value="">{label}</option>
                            {field.options.map((option, j) => (
                                <option key={j} value={option.optionValues[languageId]}>
                                    {option.optionValues[languageId]}
                                </option>
                            ))}
                        </select>
                    );
                    break;

                case 3: // Textbox
                case 5: // Emailbox
                    inputElement = (
                        <input
                            type={field.fieldControl === 5 ? "email" : "text"}
                            className="form-control"
                            required={isRequired}
                            value={value}
                            placeholder={label}
                            onChange={(e) =>
                                handleAdditionalFieldChange(ticket.id, field.saveToField, e.target.value)
                            }
                        />
                    );
                    break;

                case 0: // Radiobutton list
                    inputElement = (
                        <div>
                            <label>{label}</label>
                            {field.options.map((option, j) => (
                                <div className="form-check" key={j}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name={`${ticket.id}_${fieldName}`}
                                        id={`${ticket.id}_${fieldName}_${j}`}
                                        value={option.optionValues[languageId]}
                                        checked={value === option.optionValues[languageId]}
                                        onChange={(e) =>
                                            handleAdditionalFieldChange(ticket.id, field.saveToField, e.target.value)
                                        }
                                    />
                                    <label className="form-check-label" htmlFor={`${ticket.id}_${fieldName}_${j}`}>
                                        {option.optionValues[languageId]}
                                    </label>
                                </div>
                            ))}
                        </div>
                    );
                    break;

                case 1: // Checkbox list
                    inputElement = (
                        <div>
                            <label>{label}</label>
                            {field.options.map((option, j) => {
                                const optionValue = option.optionValues[languageId];
                                return (
                                    <div className="form-check" key={j}>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={`${ticket.id}_${fieldName}_${j}`}
                                            value={optionValue}
                                            checked={(ticket[fieldName] || "")
                                                .split(",")
                                                .includes(optionValue)}
                                            onChange={(e) =>
                                                handleCheckboxListChange(ticket.id, field.saveToField, optionValue, e.target.checked)
                                            }
                                        />
                                        <label className="form-check-label" htmlFor={`${ticket.id}_${fieldName}_${j}`}>
                                            {optionValue}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    );
                    break;

                default:
                    continue;
            }

            formElements.push(
                <div key={i} className="mb-3">
                    {inputElement}
                    {ticket.isValid === false && isRequired && !value && (
                        <div className="mt-2 d-flex">
                            <span className="text-error">
                                {resources?.ErrorPleaseFillMandatoryField}
                            </span>
                        </div>
                    )}
                </div>
            );
        }

        return <div>{formElements}</div>;
    };


    const handleAdditionalFieldChange = (ticketId, saveToField, value) => {

        setTickets((prevTickets) =>
            prevTickets.map((ticket) =>
                ticket.id === ticketId
                    ? {
                        ...ticket, [getFieldNameByFieldId(saveToField)]: value,
                    }
                    : ticket
            )
        );
    };

    const handleCheckboxListChange = (ticketId, saveToField, value, checked) => {
        setTickets((prevTickets) =>
            prevTickets.map((ticket) => {
                if (ticket.id !== ticketId) return ticket;

                const fieldName = getFieldNameByFieldId(saveToField);
                const prevString = ticket[fieldName] || "";
                const prevValues = prevString ? prevString.split(",") : [];

                let updatedValues;
                if (checked) {
                    updatedValues = prevValues.includes(value)
                        ? prevValues
                        : [...prevValues, value];
                } else {
                    updatedValues = prevValues.filter((v) => v !== value);
                }

                return {
                    ...ticket,
                    [fieldName]: updatedValues.join(","),
                };
            })
        );
    };

    const mapTicketsUserData = () => {

        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.id - b.id);
        }

        return (
            tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((tt, index) => (
                <>
                    {tt.ticketType?.additionalFields && tt.ticketType?.additionalFields.length > 0 &&
                        <div key={tt.id} className="tickets-box mb-5 p-3">

                            <div className="row">
                                <div className="col-md-12">
                                    <button
                                        className="btn btn-custom btn-custom-workshops-white"
                                        style={{ maxWidth: '350px' }}
                                        onClick={() => onClickFillUserData(tt.id)}
                                    >
                                        {resources?.WorkshopsTakeBuyerData}
                                    </button>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <span className="text-subtitle">{tt.info?.name}</span>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div className="col">
                                    {mapAddtionalFields(tt, tt.ticketType.additionalFields)}
                                </div>
                            </div>
                        </div>
                    }
                </>
            ))
        );
    }

    return (
        <>
            <Header language={language} pagePath="workshop-ticket" />
            <div className="page-container">

                {/* progress bar */}
                <div className="progressbar-wrapper">
                    <div className="progressbar-lines">
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                    </div>

                    <div className="progressbar-steps">
                        <div className="progress-step completed cursor-pointer" onClick={() => navigate(`/${language}/home`)}>
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 1" />
                            </div>
                            <div className="label">{resources?.ProgressTickets}</div>
                        </div>

                        <div className={`progress-step completed${countSaturdayTickets > 0 || countSundayTickets > 0 ? " cursor-pointer" : ""}`} onClick={() => {
                            if (countSaturdayTickets > 0) {
                                navigate(`/${language}/workshops-saturday`);
                            } else if (countSundayTickets > 0) {
                                navigate(`/${language}/workshops-sunday`);
                            }
                        }}>
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 2" />
                            </div>
                            <div className="label">
                                {resources?.ProgressWorkshops}<br />{resources?.ProgressOptional}
                            </div>
                        </div>

                        <div className="progress-step active">
                            <div className="circle">
                                <img src={imgIconProgressCompleted} alt="Step 3" />
                            </div>
                            <div className="label">{resources?.ProgressAdditionalInformation}</div>
                        </div>

                        <div className="progress-step">
                            <div className="circle">
                                <img src={imgIconProgress} alt="Step 4" />
                            </div>
                            <div className="label">{resources?.ProgressCheckout}</div>
                        </div>
                    </div>
                </div>

                <div className="container wrapper">

                    <div className="row fw-bold text-pink mt-5">
                        <div className="d-flex align-items-start">
                            <img src={imgIconInfo} alt="Increase" width="18" height="18" className="me-2" />
                            <span>{resources?.WorkshopsWhoTakesPart}</span>
                        </div>
                    </div>

                    <div className="row mt-4 mb-4">
                        <div className="col-md-12">
                            <span className="text-subtitle">{resources?.BuyerPleaseFillTicket}</span>
                        </div>
                    </div>

                    {mapTicketsUserData()}

                    <div className="row mt-4">
                        <div className="col-6">
                            <button className="btn btn-custom" onClick={() => onBackClick()}>{resources?.Back}</button>
                        </div>
                        <div className="col-6 text-end">
                            <button className="btn btn-custom" onClick={() => onSubmit()}>{resources?.Next}</button>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-12 text-center">
                            <p className="mt-4">
                                <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer language={language} />
        </>

    )
}

export default Ticket